<template>
  <div class="web-wrapper">
    <top />
    <div class="">
      <app-main />
    </div>
    <bottom />
    <float-window />
    <contact />
  </div>
</template>

<script>
import Top from './components/Top'
import AppMain from './components/AppMain'
import Bottom from './components/Bottom'
import FloatWindow from './components/floatWindow'
import contact from './components/contact'

export default {
  name: 'layoutWeb',
  components: {
    Top,
    AppMain,
    Bottom,
    FloatWindow,
    contact
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
